import { CancelDayOffSupervisor } from 'features/dayOffCancelSubordinates';
import { useTitle } from '../helpers';

/**
 * @page DayOffCancelSupervisorPage page
 */
const DayOffCancelSupervisorPage = () => {
  useTitle('Отмена отгулов подчиненных');

  return (
    <div>
      <CancelDayOffSupervisor />
    </div>
  );
};

export default DayOffCancelSupervisorPage;
